let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Form = require("./Form");
let Result = require("./Result");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../utils/Constants");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingBar = require("ES/widgets/LoadingBar");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let FormUtils = require("../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../utils/AuthedUserSession");
let searchResultsToTree = require("./searchResultsToTree");

let TreeBlock = dd.createClass({
  getInitialState() {
    return {expanded: true};
  },
  __toggle: esUtils.wrapPreventDefault(function () {
    this.setState({expanded: !this.state.expanded});
  }),
  render() {
    let {title, children, indent} = this.props;
    let {expanded} = this.state;

    return dd.div({className: "TreeBlock"},
      dd.div({onClick: this.__toggle, className: "clickable"},
        dd.div({style: {marginLeft: indent}},
          dd.i({
            className: "fa fa-caret-" + (expanded ? "down" : "right"), style: {
              width: "2em",
              textAlign: "center"
            }
          }),
          title
        )
      ),
      dd.div({className: "tree-block-body" + (expanded ? "" : " tree-block-closed")},
        children
      )
    );
  }
});

let SearchStatus = dd.createClass({
  render() {
    let {ajax} = this.props;
    let n_results = _.isArray(ajax.data) ? _.size(ajax.data) : -1;

    if (ajax.error) {
      return ErrorAlert({message: ajax.error});
    } else if (ajax.waiting) {
      return dd.div(null,
        dd.h4(null, "Searching..."),
        LoadingBar()
      );
    } else if (n_results < 0) {
      return dd.h4(null, "What would you like to search?");
    } else if (n_results === 0) {
      return dd.h4(null, "No results");
    } else if (n_results === 1) {
      return dd.h4(null, n_results + " result");
    } else {
      return dd.h4(null, n_results + " results");
    }
  }
});

module.exports = dd.createClass({
  mixins: [RadioServiceMixin],
  RadioService_setup() {
    return {
      EventSearch_search: {key: "callService"}
    };
  },
  RadioService_Radio_setup() {
    return {
      EventSearchAside_search(query) {
        this.RadioService_callService("EventSearch_search", query);
      }
    };
  },
  __onSubmit(data) {
    const filter_to_sid = data.speaker ? data.speaker : 0;
    let q = {
      searchterm: data.searchterm,
      deepsearch: !!data.deepsearch,
      marketplaceonly: !!data.marketplaceonly,
      datelessonly: !!data.datelessonly,
      cross_companies: !!data.cross_companies,
      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"]),
      exclude_event_types: [Constants.EVENT_STATUSES.zimbra],
      hide_closed_events: !!data.hide_closed_events
    };
    if (filter_to_sid > 0) {
      q.sids = [filter_to_sid];
    }
    if (!data.includecanceled) {
      q.exclude_event_types.push(Constants.EVENT_STATUSES.canceled);
    }
    this.RadioService_callService("EventSearch_search", q);
  },
  render() {
    let {Displaylists} = this.props;
    let my_speaker_names_by_sid = _.object(_.map(Displaylists && Displaylists.perspeaker, function (speaker) {
      return [speaker.sid, speaker.name_full];
    }));
    let my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, true);

    let ajax = this.state.EventSearch_search;
    let results_tree = searchResultsToTree(ajax.data);

    return dd.div({className: "container-fluid"},
      dd.div({className: "panel panel-default"},
        dd.div({
            className: "panel-heading", style: {
              background: "#428BCA",
              color: "#FFFFFF"
            }
          },
          dd.h4(null, "Search EventCX"),
          Form({onSubmit: this.__onSubmit, speakers: my_speakers, Displaylists})
        ),
        dd.div({className: "panel-body", style: {minHeight: "20em"}},
          SearchStatus({ajax}),
          _.map(results_tree, function (results_by_sid, group_name) {
            return TreeBlock({key: group_name, title: group_name, indent: 0},
              _.map(results_by_sid, function (results, sid) {
                let name = _.has(my_speaker_names_by_sid, sid)
                  ? my_speaker_names_by_sid[sid]
                  : "-- no speaker --";
                return TreeBlock({key: sid, title: name, indent: "3em"},
                  _.map(_.sortBy(results, function (result) {
                    let d = result.this_result_date;
                    return _.isDate(d) ? d.getDate() : -1;
                  }), function (result, i) {
                    return Result({key: i, indent: "7em", result, Displaylists});
                  })
                );
              })
            );
          })
        )
      )
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/TreeSearch/index.js